import './nao-lidas.css';

export type NaoLidasProps = {
  quantidade: number;
  /** Do que são as não lidas, para o leitor de tela: "mensagens", "conversas". */
  de?: string;
};

/**
 * Acima de 99 vira "99+".
 *
 * Três dígitos esticam a pastilha o suficiente para empurrar a hora na linha
 * densa da fila — e a diferença entre 112 e 340 não muda o que a pessoa faz.
 */
export function NaoLidas({ quantidade, de = 'não lidas' }: NaoLidasProps) {
  if (quantidade <= 0) return null;
  return (
    <span className="nao-lidas" aria-label={`${quantidade} ${de}`}>
      {quantidade > 99 ? '99+' : quantidade}
    </span>
  );
}
